const { createContext } = require("react");

export const userContext = createContext();
